/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";
import { hasCap } from "../../lib/permissions";

export default {
  getVendorProfile: () => {
    let url = `/shop/vendor/user`;
    let result = coreApi.GET(url);
    return result;
  },
  getVendorTransactions: (data) => {
    const { vendor_id } = data;
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/shop/vendors/${vendor_id}/payments${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getVendorOverview: (data) => {
    const { vendor_id, ...rest } = data;
    data = rest;
    const user = JSON.parse(localStorage.getItem("user"));
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    // A vendor reads their own overview via /shop; the backoffice overview
    // requires the vendors.view capability (supers included).
    const isBackofficeViewer = !user?.is_vendor && hasCap(user, "vendors.view");
    let url = isBackofficeViewer
      ? `/backoffice/vendors/${vendor_id}/overview${qp}`
      : `/shop/vendors/${vendor_id}/overview${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getVendorSettlements: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/shop/vendor/settlements${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getVendorQRCode: () => {
    let url = `/merchant/qr-code`;
    let result = coreApi.GET(url);
    return result;
  },
  updateDiscountPercentage: (data) => {
    let url = `/merchant/discount-percentage`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  downloadQRCode: () => {
    let url = `/merchant/qr-code/download`;
    let result = coreApi.GET(url);
    return result;
  },
  updateVendorProfile: (data) => {
    let url = `/shop/vendor/user`;
    let result = coreApi.formPUT(url, data);
    return result;
  },
};

